import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { LIST_STALE_TIME } from '../../lib/queryDefaults';
import { unwrap } from '../../data/api';
import { guidedFlowAPI } from '../../data/auth';

export const guidedFlowKeys = {
  all: ['guided-flow'],
};

/** Refetch guided-flow after actions that complete or change a step. */
export function invalidateGuidedFlow(qc) {
  void qc.invalidateQueries({ queryKey: guidedFlowKeys.all });
}


export function useGuidedFlowQuery(queryOptions = {}) {
  return useQuery({
    queryKey: guidedFlowKeys.all,
    queryFn: () => guidedFlowAPI.get().then((r) => unwrap(r)),
    staleTime: LIST_STALE_TIME,
    placeholderData: (prev) => prev,
    refetchOnWindowFocus: true,
    ...queryOptions,
  });
}

export function useGuidedFlowAdvanceMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => guidedFlowAPI.advance().then((r) => unwrap(r)),
    onSuccess: (state) => {
      if (state) qc.setQueryData(guidedFlowKeys.all, state);
      qc.invalidateQueries({ queryKey: guidedFlowKeys.all });
    },
  });
}

export function useGuidedFlowSkipMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => guidedFlowAPI.skip().then((r) => unwrap(r)),
    onSuccess: (state) => {
      if (state) qc.setQueryData(guidedFlowKeys.all, state);
      qc.invalidateQueries({ queryKey: guidedFlowKeys.all });
    },
  });
}
